import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const services = [
  {
    title: 'Brand Development',
    description: 'Brand identity, strategy, and visual direction for new and growing brands.',
    to: '/brand-development'
  },
  {
    title: 'Content Production',
    description: 'Commercial film, video, and photography for brands and campaigns.',
    to: '/content-production'
  },
  {
    title: 'Social Media Marketing',
    description: 'Content and campaigns built for the platforms where your audience spends time.',
    to: '/social-media-marketing'
  },
  {
    title: 'Digital Marketing',
    description: 'Websites, email, and digital campaigns designed around your brand.',
    to: '/digital-marketing'
  },
  {
    title: 'E-Commerce Optimization',
    description: 'Online store design and product presentation that reflect your brand.',
    to: '/ecommerce-optimization'
  }
];

export default function PhilosophySection() {
  return (
    <section id="philosophy" className="bg-black py-40 md:py-64 px-6 md:px-12 overflow-hidden flex justify-center">
      <div className="w-full max-w-6xl">
        <motion.h2
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8 }}
          className="text-5xl md:text-7xl lg:text-8xl text-white tracking-tight mb-24 md:mb-32 font-serif flex items-baseline flex-wrap"
        >
          <span>The Creative</span>
          <em className="italic text-white/40 mx-4">Anomaly.</em>
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 md:gap-24 items-center">
          {/* Left Column - Video */}
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.8 }}
            className="rounded-3xl overflow-hidden aspect-[4/3] relative"
          >
            <video
              className="absolute inset-0 w-full h-full object-cover"
              muted
              autoPlay
              loop
              playsInline
              preload="auto"
              src="https://d8j0ntlcm91z4.cloudfront.net/user_38xzZboKViGWJOttwIXH07lWA1P/hf_20260307_083826_e938b29f-a43a-41ec-a153-3d4730578ab8.mp4"
            />
          </motion.div>

          {/* Right Column - Services */}
          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.8 }}
            className="flex flex-col gap-8"
          >
            <div>
              <h3 className="text-white/40 text-xs tracking-widest uppercase mb-6">
                [WHAT WE DO]
              </h3>
              <p className="text-white/70 text-lg md:text-xl leading-relaxed font-light">
                Sans Titre is a California-based creative studio. We create brand identities, films, and digital experiences for brands that want to be seen clearly.
              </p>
            </div>

            <ul className="flex flex-col">
              {services.map((service) => (
                <li key={service.to} className="border-t border-white/10 last:border-b">
                  <Link
                    to={service.to}
                    className="group flex items-start justify-between gap-6 py-5"
                  >
                    <div>
                      <h4 className="text-white text-lg md:text-xl font-light">
                        {service.title}
                      </h4>
                      <p className="text-white/50 text-sm md:text-base font-light mt-1">
                        {service.description}
                      </p>
                    </div>
                    <span className="text-white/30 group-hover:text-white group-hover:translate-x-1 transition-all duration-300 mt-1">
                      →
                    </span>
                  </Link>
                </li>
              ))}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>
  );
}